import React, { useEffect, useState } from 'react';
import { Users } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import api from '../../lib/api';

export const CommitteeRoster = () => {
  const [signups, setSignups] = useState(null);

  useEffect(() => {
    api.get('/admin/volunteer-signups').then((res) => setSignups(res.data || [])).catch(() => setSignups([]));
  }, []);

  if (signups === null) return <p className="text-[#5f6d51]/60 text-sm py-4">Loading…</p>;

  const groups = {};
  const order = [];
  signups.forEach((s) => {
    const key = s.opportunity || 'Other';
    if (!groups[key]) { groups[key] = []; order.push(key); }
    groups[key].push(s);
  });

  if (!order.length) {
    return <p className="text-[#5f6d51]/60 text-sm py-4" data-testid="committee-roster-empty">No committee signups yet.</p>;
  }

  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="committee-roster">
      {order.map((name) => (
        <Card key={name} className="border border-[#5d6b3c]/15 bg-[#f1e3eb]/40" data-testid={`committee-roster-${name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}>
          <CardContent className="p-5">
            <div className="flex items-start justify-between gap-2 mb-3">
              <h3 className="font-serif text-lg text-[#3c4a2a] leading-snug">{name}</h3>
              <Badge className="bg-[#5d6b3c]/15 text-[#5d6b3c] flex-shrink-0">
                <Users className="w-3 h-3 mr-1" />
                {groups[name].length}
              </Badge>
            </div>
            <ul className="space-y-2">
              {groups[name].map((m) => (
                <li key={m.id || m.email} className="text-sm border-b border-[#bd8cae]/20 last:border-0 pb-2 last:pb-0">
                  <p className="text-[#3c4a2a] font-medium">{m.name}</p>
                  <p className="text-[#3c4a2a]/60 text-xs">{m.email}</p>
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
